// convex/validators/categories.ts
import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";
import { customFieldValues } from "../../custom_fields";

export const categoryStatus = v.union(
	v.literal("active"),
	v.literal("inactive"),
);

export const categoryType = v.optional(
	v.union(v.literal("product"), v.literal("service")),
);

export const validatorCategory = v.object({
	name: v.string(),
	description: v.optional(v.string()),
	type: categoryType,
	parentCategoryId: v.optional(v.id("categories")), // Para categorías anidadas
	imageId: v.optional(v.id("_storage")),
	icon: v.optional(v.string()), // Emoji o nombre de ícono
	color: v.optional(v.string()), // Color hex para UI
	internalControl,
	/** Valores de campos personalizados (Colecciones), por key de definición. */
	customFields: v.optional(customFieldValues),
});

export const categories = defineTable(validatorCategory)
	.index("by_company_id", ["internalControl.companyId"])
	.index("by_company_and_type", ["internalControl.companyId", "type"])

	.index("by_parent", ["parentCategoryId"])
	.index("by_company_state", [
		"internalControl.companyId",
		"internalControl.state",
	])
	.index("by_name", ["internalControl.companyId", "name"]);
